<script>
    import { Router, Link, Route } from "svelte-routing";
    import ListRoute from "./list/list.html";
    import AddUpdate from "./addupdate/addupdate.html";
</script>

<Router>

    <Route path="edit/:id" let:params>
        <AddUpdate _id="{params.id}"></AddUpdate>

    </Route>
    <Route path="">
        <ListRoute></ListRoute>
    </Route>
</Router>



